// elements/InfoComponent.jsx (for target application)
import React from 'react';
import { useTheme } from '../themes/ThemeProvider';

const InfoComponent = ({ id, title, content }) => {
  const { theme } = useTheme();
  
  return (
    <div className={`${theme.infoBox?.container + ' mt-2' || 'p-3 bg-gray-800 rounded mb-3'}`}>
      <div className={`${theme.infoBox?.title || 'font-medium mb-1'}`}>
        {title || 'Information'}
      </div>
      <div className={`${theme.infoBox?.content || 'text-sm text-gray-300'}`}>
        {content || ''}
      </div>
    </div>
  );
};

export default InfoComponent;